export default "__VITE_ASSET__07436c2f__"